import { Theme } from "@aws-amplify/ui-react";

const brightGreen = "#6DF0B1";
const whiteBG= "#FFF";
const darkText = "#111";

export const theme : Theme = {
    name: 'my-theme',
    tokens: {
        components: {
            button : {
                primary: {
                    backgroundColor: brightGreen,
                    color: darkText,
                    _hover: {
                        borderColor: brightGreen,
                        backgroundColor: darkText,
                        color: whiteBG,
                    }
                },
                borderRadius: "20px",
                _hover : {
                    backgroundColor: brightGreen
                }
            }
        }
    }
}